import { render, staticRenderFns } from "./apinv-request-frm.vue?vue&type=template&id=6309f366"
import script from "./apinv-request-frm.vue?vue&type=script&lang=js"
export * from "./apinv-request-frm.vue?vue&type=script&lang=js"
import style0 from "./apinv-request-frm.vue?vue&type=style&index=0&id=6309f366&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports